export default {
  inserted: function (el, bindings, node) {
    if (!process.browser) return;
    if (el) el.setAttribute('data-lazy-view',true);
    
    const checkView = function () {
      const offsetTop = ((element) => {
        let yPosition = 0;
        let nextElement = element;
        while (nextElement) {
          if (typeof nextElement === 'object' && nextElement.offsetTop > -1) {
            yPosition += (nextElement.offsetTop);
            nextElement = nextElement.offsetParent;
          }
        }
        return yPosition;
      })(el);
      
      let scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      if (scrollTop + window.innerHeight > offsetTop) {
        if (el) el.setAttribute('data-in-view', true);
        window.removeEventListener('scroll', checkView)
      }
    };
    
    window.addEventListener('scroll', checkView);
    el && checkView();
  },
  unbind(el) {
    if (el) {
      delete el.removeAttribute('data-lazy-view');
    }
  }
}
